<template id="app">
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header-->
    <header-component :headerTitle="headerText" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()"
      :component-name="componentsName()" />
    <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage" :color="primary_code">
    </loading>
    <!-- Add Location Master -->
      <v-form ref="createForm" class="dynamic-height-form">
        <v-card class="v-card-100">
          <v-card-text>
            <div v-if="headerTextSub === 'Master Location'">
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="4" md="4" class="text-left">
                  <span class="text-align">Location Details *</span>
                </v-col>
                <v-col cols="2" sm="4" md="4" class="text-left">
                  <v-text-field hide-details="auto" v-model="location_id" label="Location ID" variant="outlined" type="text"  @keyup="locationIDUnique(location_id)" :disabled="disable_field"></v-text-field>
                  <div><a class="generate-style" :class="{ 'disabled-link': disable_field }" href="#" @click="locationIDUnique(location_id)">Generate Location ID</a></div>
                </v-col>
                <v-col cols="3" sm="4" md="4">
                  <v-text-field v-model="location_name" label="Location Name" variant="outlined"
                    type="text"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="4" sm="4" md="4">
                  <span></span>
                </v-col>
                <v-col cols="4" sm="4" md="4">
                  <v-combobox v-model="location_type" :items="location_type_item" item-title="name" item-value="id"
                    label="Location Type" variant="outlined">
                  </v-combobox>
                </v-col>
                <v-col cols="3" sm="4" md="4">
                  <v-text-field v-model="location_head" label="Location Head" variant="outlined"
                    type="text"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="4" md="4" class="text-left">
                  <span class="text-align">Address *</span>
                </v-col>
                <v-col cols="2" sm="4" md="4">
                  <v-text-field v-model="street_address" label="Street Address" variant="outlined"
                    type="text"></v-text-field>
                </v-col>
                <v-col cols="3" sm="4" md="4">
                  <v-combobox v-model="city" label="City" :items="city_items" item-title="name" item-value="id"
                    variant="outlined" type="text"></v-combobox>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="4" md="4">
                  <span></span>
                </v-col>
                <v-col cols="2" sm="4" md="4">
                  <v-combobox v-model="state" :items="state_items" item-title="name" item-value="id" label="State"
                    variant="outlined" type="text"></v-combobox>
                </v-col>
                <v-col cols="3" sm="4" md="4">
                  <v-combobox v-model="country" :items="country_items" item-title="name" item-value="id" label="Country"
                    variant="outlined" type="text"></v-combobox>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="4" md="4">
                  <span></span>
                </v-col>
                <v-col cols="2" sm="4" md="4">
                  <v-text-field v-model="pin_code" label="PIN Code" variant="outlined" type="text" :rules="pinCodeValidation" @keyup="checkinkValidPicode(pin_code)"></v-text-field>
                </v-col>
                <v-col cols="3" sm="4" md="4">
                  <span></span>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="4" sm="4" md="4" class="text-left">
                  <span class="text-align">Location Mapping</span>
                </v-col>
                <v-col cols="4" sm="4" md="4">
                  <v-combobox v-model="branch" :items="branch_item" label="Branch" variant="outlined"
                    prepend-inner-icon="mdi-magnify">
                  </v-combobox>
                </v-col>
                <v-col cols="3" sm="4" md="4">
                  <v-combobox v-model="zone" :items="zone_item" label="Zone" variant="outlined"
                    prepend-inner-icon="mdi-magnify">
                  </v-combobox>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="4" md="4">
                  <span></span>
                </v-col>
                <v-col cols="2" sm="4" md="4">
                  <v-combobox v-model="region" :items="region_item" label="Region" variant="outlined"
                    prepend-inner-icon="mdi-magnify">
                  </v-combobox>
                </v-col>
                <v-col cols="3" sm="4" md="4">
                  <span></span>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="4" md="4" class="text-left">
                  <span class="text-align">Location POC *</span>
                </v-col>
                <v-col cols="2" sm="4" md="4">
                  <v-text-field v-model="name_of_person" label="Name Of Person" variant="outlined"
                    type="text"></v-text-field>
                </v-col>
                <v-col cols="3" sm="4" md="4">
                  <v-text-field v-model="mobile_number" label="Mobile Number" variant="outlined" type="text" :rules="mobileNumberValidation" @keyup="checkinkValid(mobile_number)"></v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="4" md="4">
                  <span></span>
                </v-col>
                <v-col cols="2" sm="4" md="4">
                  <v-text-field v-model="email" label="Email" variant="outlined" type="text"
                    :rules="emailValidation"></v-text-field>
                </v-col>
                <v-col cols="3" sm="4" md="4">
                  <span></span>
                </v-col>
              </v-row>
            </div>
            <div v-else-if="headerTextSub === 'Forward Location Mapping' || headerTextSub === 'Reverse Location Mapping'">
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="4" md="4" class="text-left">
                  <span class="text-align">Master Location</span>
                </v-col>
                <v-col cols="2" sm="4" md="4">
                  <v-combobox v-model="master_location" :items="master_location_item" item-title="code" item-value="id"
                    label="Master Location" variant="outlined" prepend-inner-icon="mdi-magnify">
                  </v-combobox>
                </v-col>
                <v-col cols="3" sm="4" md="4">
                  <span></span>
                </v-col>
              </v-row>
              <v-row v-if="headerTextSub === 'Forward Location Mapping'" style="margin-bottom: -25px;">
                <v-col cols="1" sm="4" md="4" class="text-left">
                  <span class="text-align">Forward Child Location</span>
                </v-col>
                <v-col cols="2" sm="4" md="4">
                  <v-row v-for="(row, index) in rows" :key="index" >
                    <v-col cols="2" sm="11" md="11" class="d-flex">
                      <v-combobox v-model="row.search_select_loc" :items="filtered_distribution_centers"
                        item-title="code" item-value="id" label="Search & select the location" variant="outlined"
                        prepend-inner-icon="mdi-magnify" hide-details="auto">
                      </v-combobox>
                      <span :style="computedStyle"><img src="@/assets/images/delete_red.png" title="Delete item" :class="{ hidden: rows.length <= 1 }"
                          @click="deleteRow(index)" /></span>
                    </v-col>

                  </v-row>
                  <div><a class="generate-style" href="#" @click="addNewRow(row, index)"><v-icon small color="#1976d2"
                        class="mr-1">mdi-plus</v-icon>Add More</a></div>
                </v-col>
              </v-row>
              <v-row v-if="headerTextSub === 'Reverse Location Mapping'" style="margin-bottom: -25px;">
                <v-col cols="1" sm="4" md="4" class="text-left">
                  <span class="text-align">Reverse Child Location</span>
                </v-col>
                <v-col cols="2" sm="5" md="5">
                  <v-row v-for="(row, index) in rows" :key="index">
                    <v-col cols="2" sm="11" md="11" class="d-flex">
                      <v-combobox v-model="row.search_select_loc" :items="filtered_distribution_centers"
                        item-title="code" item-value="id" label="Search & select the location" variant="outlined"
                        prepend-inner-icon="mdi-magnify" hide-details="auto">
                      </v-combobox>
                      <span :style="computedStyle"><img src="@/assets/images/delete_red.png" title="Delete item" :class="{ hidden: rows.length <= 1 }"
                          @click="deleteRow(index)" /></span>
                    </v-col>

                  </v-row>
                  <div><a class="generate-style" href="#" @click="addNewRow(row, index)"><v-icon small color="#1976d2"
                        class="mr-1">mdi-plus</v-icon>Add More</a></div>
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <span></span>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-form>
      <v-card-actions class="submit-actions">
        <v-spacer></v-spacer>
        <v-btn variant="outlined" color="primary" @click="navigateToHome">CANCEL</v-btn>
        <v-btn variant="flat" color="primary" v-if="headerTextSub === 'Master Location' && this.$store.state.action === 'add'"
          @click="createLocationMaster"
          :disabled="!location_id || !location_name || !location_type || !location_head || !street_address || !city || !state || !country || !pin_code || !name_of_person || !mobile_number || !email  || !numbervalid || !pincode_valid">SUBMIT</v-btn>
        <v-btn variant="flat" color="primary" v-if="headerTextSub === 'Master Location' && this.$store.state.action === 'edit'"
          @click="updateLocationMaster"
          :disabled="!location_id || !location_name || !location_type || !location_head || !street_address || !city || !state || !country || !pin_code || !name_of_person || !mobile_number || !email">Update</v-btn>
        <v-btn color="primary"
          v-if="headerTextSub === 'Forward Location Mapping' && this.$store.state.action === 'edit'"
          @click="updateLocationMappingMaster"
          :disabled="master_location === '' || rows.some(row => row.search_select_loc === '')">Update</v-btn>
        <v-btn variant="flat" color="primary" v-if="headerTextSub === 'Forward Location Mapping' && this.$store.state.action === 'add'"
          :disabled="master_location === '' || rows.some(row => row.search_select_loc === '')"
          @click="createForwardLocation">SUBMIT</v-btn>
        <v-btn variant="flat" color="primary" v-if="headerTextSub === 'Reverse Location Mapping' && this.$store.state.action === 'add'"
          :disabled="master_location === '' || rows.some(row => row.search_select_loc === '')"
          @click="createReverseLocation">SUBMIT</v-btn>
        <v-btn variant="flat" color="primary"
          v-if="headerTextSub === 'Reverse Location Mapping' && this.$store.state.action === 'edit'"
          @click="updateLocationReverseMappingMaster"
          :disabled="master_location === '' || rows.some(row => row.search_select_loc === '')">Update</v-btn>
      </v-card-actions>
  </v-card>
</template>
<script>
import HeaderComponent from "../../../../../commoncomponents/HeaderComponent.vue"
// import 'vue-loading-overlay/dist/vue-loading.css';
import { DynamicHeightMixin } from '../../../../../commoncomponents/DynamicHeightMixin';
import Loading from 'vue-loading-overlay';

export default {
  mixins: [DynamicHeightMixin],
  components: {
    HeaderComponent, Loading
  },
  data() {
    return {
      headerText: "Location Module",
      alert: false,
      alert_type: 'success',
      alert_message: '',
      isLoading: false,
      location_id: '',
      location_name: '',
      location_type: '',
      location_type_item: [],
      street_address: '',
      city: '',
      state: '',
      country: '',
      pin_code: '',
      branch: '',
      branch_item: [],
      zone: '',
      zone_item: [],
      region: '',
      region_item: [],
      name_of_person: '',
      mobile_number: '',
      email: '',
      headerTextSub: '',
      master_location: '',
      master_location_item: [],
      rows: [
        {
          search_select_loc: '',
        }
      ],
      city_items: [],
      state_items: [],
      country_items: [],
      message: '',
      location_head: '',
      location_details: [],
      filtered_distribution_centers: '',
      fullPage: true,
      primary_code: '#0275d8',
      disable_field:false,
      pinCodeValidation: [
        v => !!v || 'PIN code is required',
        v => /^[0-9]{6}$/.test(v) || 'PIN code must be 6 digits'
      ],
      mobileNumberValidation: [
        v => !!v || 'Mobile number is required',
        v => /^[0-9]{10}$/.test(v) || 'Mobile number must be 10 digits'
      ],
      emailValidation: [
        v => !!v || 'Email is required',
        v => /.+@.+\..+/.test(v) || 'Email must be valid (e.g., example@example.com)'
      ],
      numbervalid: false,
      pincode_valid:false
    }
  },
  async created() {
    // this.item_id = this.$store.state.lotIds.id;
    this.headerTextSub = this.$store.state.inventoryId;
    this.selectCodeList()
    this.fetchFilterData()
    if (this.$store.state.action === 'edit') {
      this.editDataUpdate()
    }
  },
  watch: {
    master_location: {
      handler() {
        this.filterSearchSelectLocItems();
      },
      deep: true
    }
  },
  computed: {
    computedStyle() {
      return {
        margin: this.rows.length > 1 ? '20px' : '40px'
      };
    }
  },
  methods: {
    checkinkValid(value){
      if(value.length === 10){
        this.numbervalid = true;
      }else{
        this.numbervalid = false;
      }
    },
    checkinkValidPicode(value){
      if(value.length === 6){
        this.pincode_valid = true;
      }else{
        this.pincode_valid = false;
      }
    },
    filterSearchSelectLocItems() {
      this.filtered_distribution_centers = this.search_select_loc_item.filter(center => {
        return center.id !== this.master_location.id;
      });
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    getRouterLink() {
      if (this.headerTextSub === "Master Location") {
        this.$store.commit("setActiveTab", {
          active_tab: 'first_tab'
        });
        return { name: "locationMaster" };
      } else if (this.headerTextSub === "Forward Location Mapping") {
        this.$store.commit("setActiveTab", {
          active_tab: 'second_tab'
        });
        return { name: "locationMaster" };
      } else if (this.headerTextSub === "Reverse Location Mapping") {
        this.$store.commit("setActiveTab", {
          active_tab: 'third_tab'
        });
        return { name: "locationMaster" };
      }
    },
    componentsName() {
      if (this.headerTextSub === "Master Location") {
        return 'Add Location Master';
      } else if (this.headerTextSub === "Forward Location Mapping") {
        return 'Add Forward Location Mapping'
      } else if (this.headerTextSub === "Reverse Location Mapping") {
        return 'Add Reverse Location Mapping'
      }
    },
    getRouterLinkText() {
      if (this.headerTextSub === "Master Location") {
        return this.headerTextSub;
      } else if (this.headerTextSub === "Forward Location Mapping") {
        return this.headerTextSub
      } else if (this.headerTextSub === "Reverse Location Mapping") {
        return this.headerTextSub
      }
    },
    generateLocationId() {
      const id = 'L' + (Math.floor(Math.random() * 9999) + 1).toString().padStart(4, '0');
      this.location_id = id;
    },
    addNewRow() {
      this.rows = [
        ...this.rows,
        {
          search_select_loc: ''
        }
      ];
    },
    createLocationMaster() {
      this.isLoading = true
      this.$httpSecured
        .post("/admin/distribution_centers/create_location", {
          "location_master": {
            "code": this.location_id,
            "name": this.location_name,
            "distribution_center_type_id": this.location_type.id,
            "location_head_name": this.location_head,
            "address_line1": this.street_address,
            "city_id": this.city.id,
            "state_id": this.state.id,
            "country_id": this.country.id,
            "pin_code": this.pin_code,
            "branch": this.branch,
            "zone": this.zone,
            "region": this.region,
            "poc_name": this.name_of_person,
            "poc_country_code": "+91",
            "poc_mobile": this.mobile_number,
            "poc_email": this.email
          }
        })
        .then(response => {
          if (response.data) {
            this.message = response.data;
            this.$store.commit("setLotIds", {
              lotIds: this.message,
              inventoryId: 'success'
            });
            this.isLoading = false
            this.navigateToHome()
            this.loading = false;
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.isLoading = false
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
        });
    },
    navigateToHome() {
      this.$router.push({ name: "locationMaster" });
    },
    selectCodeList() {
      this.$httpSecured
        .get(`/admin/distribution_centers/select_child`)
        .then(response => {
          if (response.data) {
            this.master_location_item = response.data.distribution_centers
            this.search_select_loc_item = response.data.distribution_centers
            this.filtered_distribution_centers = response.data.distribution_centers
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    createForwardLocation() {
      this.isLoading = true
      this.$httpSecured
        .post("/admin/distribution_centers/create_forward_location", {
          "master_location_code": this.master_location.code,
          "child_location_codes": this.rows.map(item => item.search_select_loc.code).toString()
        })
        .then(response => {
          if (response.data) {
            this.message = response.data;
            this.$store.commit("setLotIds", {
              lotIds: this.message,
              inventoryId: 'success'
            });
            this.navigateToHome()
            this.isLoading = false
            this.loading = false;
          } else {
            this.showAlert("error", "No Data Found");
            this.isLoading = false
            this.loading = false;
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
          this.isLoading = false
        });
    },
    createReverseLocation() {
      this.isLoading = true
      this.$httpSecured
        .post("/admin/distribution_centers/create_reverse_location", {
          "master_location_code": this.master_location.code,
          "child_location_codes": this.rows.map(item => item.search_select_loc.code).toString()
        })
        .then(response => {
          if (response.data) {
            this.message = response.data;
            this.$store.commit("setLotIds", {
              lotIds: this.message,
              inventoryId: 'success'
            });
            this.navigateToHome()
            this.loading = false;
            this.isLoading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.isLoading = false
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
          this.isLoading = false
        });
    },
    fetchFilterData() {
      this.$httpSecured
        .get(`/admin/distribution_centers/select_filter_data`)
        .then(response => {
          if (response.data) {
            this.location_type_item = response.data.type
            this.city_items = response.data.cities
            this.state_items = response.data.states
            this.country_items = response.data.countries
            this.branch_item = response.data.branch
            this.zone_item = response.data.zone
            this.region_item = response.data.region
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    editDataUpdate() {
      this.isLoading = true
      this.disable_field = true
      let endpoint = '';
      if (this.headerTextSub === "Master Location") {
        endpoint = `/admin/distribution_centers/${this.$store.state.lotIds}/show_location`
      } else if (this.headerTextSub === "Forward Location Mapping") {
        endpoint = `/admin/distribution_centers/${this.$store.state.lotIds}/show_mapped_location?location_type=forward_location`
      } else if (this.headerTextSub === "Reverse Location Mapping") {
        endpoint = `/admin/distribution_centers/${this.$store.state.lotIds}/show_mapped_location?location_type=reverse_location`
      }
      this.$httpSecured
        .get(endpoint)
        .then(response => {
          if (response.data) {
            if (this.headerTextSub === "Master Location") {
              this.location_details = response.data.master_location
            } else if (this.headerTextSub === "Forward Location Mapping") {
              this.location_details = response.data.master_locations
            } else if (this.headerTextSub === "Reverse Location Mapping") {
              this.location_details = response.data.master_locations
            }
            this.isLoading = false;
            this.loading = false;
            this.setEditDataParams()
          } else {
            this.loading = false;
            this.isLoading = false
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.isLoading = false
        });
    },
    setEditDataParams() {
      if (this.headerTextSub === "Master Location") {
        this.location_id = this.location_details.location_id
        this.location_name = this.location_details.location_name
        this.location_type = this.location_details.type
        this.location_head = this.location_details.location_head
        this.street_address = this.location_details.street_address
        this.city = this.location_details.city
        this.state = this.location_details.state
        this.country = this.location_details.country
        this.pin_code = this.location_details.pin
        this.branch = this.location_details.branch
        this.zone = this.location_details.zone
        this.region = this.location_details.region
        this.name_of_person = this.location_details.name
        this.mobile_number = this.location_details.mobile
        this.email = this.location_details.email
      } else if (this.headerTextSub === "Forward Location Mapping") {
        this.master_location = this.location_details.master_location
        this.rows = this.location_details.child_location.map(child => {
          return {
            search_select_loc: child.child_location_code,
          };
        });
      } else if (this.headerTextSub === "Reverse Location Mapping") {
        this.master_location = this.location_details.master_location
        this.rows = this.location_details.child_location.map(child => {
          return {
            search_select_loc: child.child_location_code,
          };
        });
      }

    },
    updateLocationMaster(){
      let city_id = null;
      let state_id = null;
      let country_id = null;
      let location_id = null;
      if (this.city && typeof this.city === 'object') {
        city_id = this.city.id;
      } else if (this.city) {
        const city = this.city_items.find(item => item.name === this.city);
        city_id = city ? city.id : null;
      }
      if (this.state && typeof this.state === 'object') {
        state_id = this.state.id;
      } else if (this.state) {
        const state = this.state_items.find(item => item.name === this.state);
        state_id = state ? state.id : null;
        }

        if (this.country && typeof this.country === 'object') {
          country_id = this.country.id;
        } else if (this.country) {
          const country = this.country_items.find(item => item.name === this.country);
          country_id = country ? country.id : null;
        }
        if(this.location_type && typeof this.location_type === 'object'){
          location_id = this.location_type.id
        }else if(this.location_type){
          const location = this.location_type_item.find(item => item.name === this.location_type);
          location_id = location ? location.id : null;
        }

        this.isLoading = true
        this.$httpSecured
        .put(`/admin/distribution_centers/${this.$store.state.lotIds}/update_location`,{
          "location_master": {
            "code": this.location_id,
            "name": this.location_name,
            "distribution_center_type_id": location_id,
            "location_head_name": this.location_head,
            "address_line1": this.street_address,
            "city_id": city_id,
            "state_id": state_id,
            "country_id": country_id,
            "pin_code": this.pin_code,
            "branch": this.branch,
            "zone": this.zone,
            "region": this.region,
            "poc_name": this.name_of_person,
            "poc_country_code": "+91",
            "poc_mobile": this.mobile_number,
            "poc_email": this.email
          }
        })
        .then(response => {
          if (response.data) {
            this.message = response.data;
            this.$store.commit("setLotIds", {
              lotIds: this.message,
              inventoryId: 'success'
            });
            this.navigateToHome()
            this.loading = false;
            this.isLoading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.isLoading = false
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
          this.isLoading = false
        });
    },
    updateLocationMappingMaster(){
      this.isLoading = true
      const updatedChildCodes = this.rows.map(item => {
          if (typeof item.search_select_loc === 'object') {
            return item.search_select_loc.code;
          } else {
            return item.search_select_loc;
          }
        }).join(',');
        this.$httpSecured
        .put(`/admin/distribution_centers/${this.$store.state.lotIds}/update_forward_location`,
        {
         updated_child_codes: updatedChildCodes,
        })
        .then(response => {
          if (response.data) {
            this.message = response.data;
            this.$store.commit("setLotIds", {
              lotIds: this.message,
              inventoryId: 'success'
            });
            this.navigateToHome()
            this.loading = false;
            this.isLoading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.isLoading = false
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
          this.isLoading = false
        });
    },
    deleteRow(index) {
      this.rows.splice(index, 1);
    },
    updateLocationReverseMappingMaster() {
      this.isLoading = true
      const updatedChildCodes = this.rows.map(item => {
        if (typeof item.search_select_loc === 'object') {
          return item.search_select_loc.code;
        } else {
          return item.search_select_loc;
        }
      }).join(',');
      this.$httpSecured
        .put(`/admin/distribution_centers/${this.$store.state.lotIds}/update_reverse_location`,
          {
            updated_child_codes: updatedChildCodes,
          })
        .then(response => {
          if (response.data) {
            this.message = response.data;
            this.$store.commit("setLotIds", {
              lotIds: this.message,
              inventoryId: 'success'
            });
            this.navigateToHome()
            this.loading = false;
            this.isLoading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.isLoading = false
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
          this.isLoading = false
        });
    },
    locationIDUnique(value){
      const params = {
        search_code: value  
      };
      this.$httpSecured
        .get(`/admin/distribution_centers/generate_location_id`, {params:params})
        .then(response => {
          if (response.data) {
            this.location_id = response.data.generated_location_id
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    }, 
  }
}
</script>
<style scoped>
.text-align {
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #0C0C0C;
}

.form-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.dynamic-height-form {
  height: calc(var(--vh, 1vh) * 100 - 200px);
  /* Adjust the header height accordingly */
  overflow-y: auto;
}

.submit-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
  /* Adjust padding as needed */
  background-color: white;
  position: sticky;
  bottom: 0;
  width: 100%;
}

.generate-style {
  margin-left: 10px;
  color: #1976d2;
  font-size: 10px;
  cursor: pointer;
}

.v-card {
  box-shadow: none !important;
}
.hidden {
  visibility: hidden;
}
.disabled-link {
  pointer-events: none;
  color: gray;
  cursor: not-allowed;
  text-decoration: none;
}
</style>